import React from "react";
import StoreContextProvider from "./src/store/index";
import "./src/styles/global.css";
import "./src/styles/components/info-modal.css";

export const wrapRootElement = ({ element }) => (
  <StoreContextProvider>{element}</StoreContextProvider>
);
